<template>
  <b-card header="Packages">
    <section v-if="this.showLoader" class="card-loader">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </section>
    <p class="text-center" v-if="this.packages.length > 0">
      Shipping
      {{ items.map( i => +i.quantity).reduce( (i, a) => a += +i, 0) }} individual items
      in {{ packages.length }}  packages
      ({{ packages.map((i) => i['weight']).reduce((i, a) => i += a, 0) }} lbs).
    </p>
    <b-form-row class="text-center font-weight-bold">
      <b-col cols="1"></b-col>
      <b-col cols="1"></b-col>
      <b-col cols="3">Weight (lbs)</b-col>
      <b-col>Dimensions</b-col>
    </b-form-row>
    <Parcel v-for="parcel, ix in packages" :parcel="parcel" :key="ix" :index="ix" @delete-ship-parcel="deleteParcel" />
     <b-form-row>
       <b-col cols="4">
         <b-button
          style="white-space: normal;"
          :variant="invalid ? 'danger' : 'primary'"
          :disabled="invalid"
          @click="repack()"
          block
        >
          Re-Pack Items
        </b-button>
      </b-col>

      <b-col>
        <b-button @click="addParcel()" variant="success" block>
          + Add Package
        </b-button>
      </b-col>
    </b-form-row>
  </b-card>
</template>

<script>
import Parcel from './Parcel';
import ShippingService from '../../services/shipping';

export default {
  name: 'Packages',
  components: {
    Parcel,
  },
  data() {
    return {
      amILoading: false,
    }
  },
  computed: {
    showLoader() {
      return this.loading || this.amILoading;
    }
  },
  props: {
    items: { type: Array, default: [] },
    packages: { type: Array, default: [] },
    loading: { type: Boolean, default: false },
    invalid: { type: Boolean, default: true },
  },
  methods: {
    repack() {
      this.amILoading = true;
      while(this.packages.length > 0) { this.packages.pop(); }
      ShippingService.getPackaging(this.items).then( d => {
        d.forEach( p => this.packages.push(p) )
        this.amILoading = false;
      } );
    },
    addParcel() {
      const blank_parcel = {
        contents: [],
        dimensions: [9,9,9],
        weight: 1,
        special: [],
        value: 0,
      };
      this.packages.push(blank_parcel);
    },
    deleteParcel(ix) {
      this.packages.splice(ix, 1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pack-and-ship/Packages.vue